<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <multiselect :id="id" ref="input" v-model="selected" :multiple="multiple" :options="options" :searchable="searchable" :close-on-select="close_on_select" :show-labels="false" :class="{ error: error }" class="" placeholder="Wybierz" :track-by="track_by" :label="opt_label" :disabled="isDisabled"></multiselect>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `select-input-${this._uid}`
      },
    },
    value: [String, Number, Boolean, Array, Object],
    label: String,
    error: String,
    options: [Array, Object],
    close_on_select: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    track_by: String,
    opt_label: String
  },
  data() {
    return {
      selected: this.value,
    }
  },
  watch: {
    selected(selected) {
      this.$emit('input', selected)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
